var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "lazy",
          rawName: "v-lazy:background-image",
          value: _vm.image ? _vm.image : "/img/estate-placeholder.jpg",
          expression: "image ? image : '/img/estate-placeholder.jpg'",
          arg: "background-image"
        }
      ],
      staticClass: "lazy-image crop-center",
      class: _vm.additionalClass
    },
    [
      _c("img", {
        directives: [
          {
            name: "lazy",
            rawName: "v-lazy",
            value: _vm.image ? _vm.image : "/img/estate-placeholder.jpg",
            expression: "image ? image : '/img/estate-placeholder.jpg'"
          }
        ],
        attrs: { alt: "" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }